import { usePage } from '@inertiajs/vue3'

export const hasSubscription = (limit) =>
  usePage().props._user.active_company?.subscriptionLimit[limit] === true

/**
 * Whether a capability module is on for the active company (Marketplace Admin work order P1: every
 * yes/no right is a module; HandleInertiaRequests shares them as `_modules`). The client only hides or
 * shows UI with it; the server gate is authoritative.
 */
export const hasModule = (key) => {
  const page = usePage()
  return (
    Boolean(page.props._user?.active_company) &&
    Array.isArray(page.props._modules) &&
    page.props._modules.includes(key)
  )
}

/** A menu entry with a `module` shows only while that module is on. */
export const allowsMenuEntry = (entry) =>
  !entry.module || hasModule(entry.module)

export const hasCrmAccess = () => hasModule('crm')
export const hasAPIAccess = () => hasModule('api')
export const hasCustomMailerAccess = () => hasModule('custom-mailer')
export const hasChatAccess = () => hasSubscription('has_chat_access')
export const hasCustomSmsSender = () => hasModule('sms-sender')
